<script setup lang="ts">
import { computed } from 'vue';
import SeasonalFlightRule from './SeasonalFlightRule.vue';

interface Props {
  seasonalSummer: any;
  seasonalWinter: any;
  seasonalException: any;
  validateSeason: any;
  seasonalDefault: any;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  'update:seasonalSummer': [value: any];
  'update:seasonalWinter': [value: any];
  'update:seasonalException': [value: any];
}>();

const seasonalSummerData = computed({
  get() {
    return props.seasonalSummer;
  },
  set(value) {
    emits('update:seasonalSummer', value);
  }
});

const seasonalWinterData = computed({
  get() {
    return props.seasonalWinter;
  },
  set(value) {
    emits('update:seasonalWinter', value);
  }
});

const seasonalExceptionData = computed({
  get() {
    return props.seasonalException;
  },
  set(value) {
    emits('update:seasonalException', value);
  }
});
</script>
<template>
  <div>
    <div class="seasonal-cntnr">
      <div>
        <SeasonalFlightRule :title="$t('common.labels.summer_season')" v-model:seasonalData="seasonalSummerData" :validateSeason="validateSeason.seasonalSummer" :seasonalDefault="seasonalDefault?.summer" />
      </div>
      <div>
        <SeasonalFlightRule :title="$t('common.labels.winter_season')" v-model:seasonalData="seasonalWinterData" :validateSeason="validateSeason.seasonalWinter" :seasonalDefault="seasonalDefault?.winter" />
      </div>
      <div>
        <SeasonalFlightRule :title="$t('common.labels.exception_season')" v-model:seasonalData="seasonalExceptionData" :validateSeason="validateSeason.seasonalException" :seasonalDefault="seasonalDefault?.exception" :isSeasonalException="true" />
      </div>
    </div>
    <p id="duration_text" class="mt-3 font-bold text-sm">*({{ $t('common.labels.duration_hint') }})</p>
  </div>
</template>
